import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
const RecomendationSkeleton = () => {
  if (PUBLIC_IS_BOT) return null;
  return <div className='col-span-full mt-6 flex flex-col gap-5 overflow-hidden' data-sentry-component="RecomendationSkeleton" data-sentry-source-file="recomendation-skeleton.tsx">
            <div className='h-6 w-40 animate-pulse rounded-md bg-gray-100' />

            <div className='flex w-full gap-2'>
                {Array(4).fill(undefined).map((_, index) => {
        return <div key={index} className='flex w-[284px] shrink-0 animate-pulse items-center justify-between gap-4 rounded-md border border-border-gray-light bg-surface-solid-0 p-2 lg:w-[344px]'>
                                <div className='h-28 w-28 animate-pulse rounded bg-gray-100 lg:h-32 lg:w-32' />

                                <div className='flex h-full grow flex-col'>
                                    <div className='h-5 w-full animate-pulse rounded bg-gray-100' />
                                    <div className='mt-1 h-10 w-full animate-pulse rounded bg-gray-100 lg:h-12' />
                                    <div className='mr-auto mt-2 h-10 w-4/5 animate-pulse rounded bg-gray-100 lg:h-12' />
                                </div>
                            </div>;
      })}
            </div>
        </div>;
};
export default RecomendationSkeleton;